import { Add } from "@mui/icons-material";
import { Button, DialogActions, DialogContent, Stack } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useMemo, useState } from "react";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import usePModelDetail from "src/hooks/product/usePModelDetail";
import useWarehouseDetailDistributionCreate from "src/hooks/warehouse/useWarehouseDetailDistributionCreate";
import useAuthGlobal from "src/context/useAuthGlobal";
import useAppGlobal from "src/context/useAppGlobal";
import BalanceWarehousePMCreate from "./BalanceWarehousePMCreate";

const childWarehouseTemp = {
  childWarehouse: "",
  percentage: "",
};

const percentageTemp = {
  productModel: "",
  childWarehouses: [childWarehouseTemp],
};
export default function BalanceWarehouseCreate() {
  const { userMe } = useAuthGlobal();
  const { closeDialog } = useAppGlobal();
  const [distribution, setDistribution] = useState([percentageTemp]);
  const [productId, setProductId] = useState();

  const { data: productModel } = usePModelDetail({ id: productId });
  const { trigger: create } = useWarehouseDetailDistributionCreate(userMe?.currentWarehouse?._id);

  const handleAddMoreProductModel = () => {
    setDistribution([...distribution, percentageTemp]);
  };

  const onCreate = async () => {
    const distributes = distribution.map((item) => ({
      productModel: item.productModel,
      childWarehouses: item.childWarehouses.map((warehouse) => ({
        childWarehouse: typeof warehouse.childWarehouse === "string" ? warehouse.childWarehouse : warehouse.childWarehouse?._id,
        percentage: Number(warehouse.percentage),
      })),
    }));
    const res = await create({
      body: {
        distributes: distributes,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const isValidDistribution = useMemo(() => {
    const total = distribution?.reduce((sum, model) => {
      return sum + model.childWarehouses.reduce((childSum, warehouse) => childSum + Number(warehouse.percentage || 0), 0);
    }, 0);

    return total <= distribution.length * 100;
  }, [distribution]);

  return (
    <>
      <DialogContent>
        <Stack py={1}>
          <SearchFilterComp
            defaultValue={productId}
            selectList={[
              {
                id: 1,
                title: "DS Sản phẩm",
                value: "products",
              },
            ]}
            getSearchKeyword={setProductId}
            autoComplete={{
              products: {
                endpoint: "/api/v1/products",
                limit: 20,
                skip: 0,
                searchField: "name",
                state: setProductId,
                label: "Sản phẩm",
                sx: { width: "100%", borderRadius: "6px", mb: 2 },
              },
            }}
          />
          <Button
            disabled={productModel?.data?.length === distribution?.length || !productId}
            onClick={handleAddMoreProductModel}
            startIcon={<Add />}
            sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", ml: "auto", mt: 2 }}
            variant="contained"
          >
            Thêm dung tích
          </Button>
          {distribution.map((_, i) => {
            return (
              <BalanceWarehousePMCreate
                i={i}
                distribution={distribution}
                setDistribution={setDistribution}
                productId={productId}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          disabled={!isValidDistribution}
          onClick={onCreate}
          fullWidth
          variant="contained"
          sx={{ mt: 4 }}
        >
          Xác nhận
        </Button>
      </DialogActions>
    </>
  );
}
